import { useAppSelector } from 'app/store/store';
import { useCallback, useMemo } from 'react';

export const useFormatMoment = () => {
  const profile = useAppSelector((state) => state.userSlice.profile);

  const isLocalTz = useMemo(() => profile?.ui?.['isLocalTz'] === 'true' ?? true, [profile]);
  const timeFormat = useMemo(() => profile?.ui?.['timeFormat'] || 'HH:mm:ss', [profile]);

  const formatMoment = useCallback(
    (moment: moment.Moment) => {
      return isLocalTz
        ? moment.locale('en').format(`DD.MM.YYYY \u2013 ${timeFormat}`)
        : moment.utc().locale('en').format(`DD.MM.YYYY \u2013 ${timeFormat} (UTC)`);
    },
    [isLocalTz, timeFormat],
  );

  return formatMoment;
};
